import { Button, Tooltip, TooltipContent, TooltipTrigger } from '@monksflow/monks-ui';
import { ArrowLeftIcon } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { PageHeaderBackButtonProps } from './PageHeader.types';

/**
 * Sole exit from a full-focus page, where the sidebar is hidden. Pair it with
 * `focus` on the header so the left inset drops to 8px and the button sits
 * optically flush with the content below.
 */
export function PageHeaderBackButton(props: PageHeaderBackButtonProps) {
  const { t } = useTranslation('common');
  const label = t('components.pageHeader.back');

  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <Button
          variant="ghost"
          size="icon-lg"
          aria-label={label}
          onClick={props.onClick}
          data-testid="page-header-back-button"
        >
          <ArrowLeftIcon />
        </Button>
      </TooltipTrigger>
      <TooltipContent side="bottom">{label}</TooltipContent>
    </Tooltip>
  );
}
